<template>
  <v-select
    v-model="internalValue"
    :items="items"
    :label="label || 'Vendedor'"
    :placeholder="placeholder || 'Seleccione un Vendedor'"
    item-value="id"
    outlined
    dense
    :error-messages="errors"
    return-object
    :loading="loading"
    :disabled="loading || disabled"
    @input="updateValue"
    hide-details="auto"
  >
    <template v-slot:selection="{ item }">
      <span class="body-2">{{item.first_name}} {{item.last_name}}</span>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title class="body-2">
          {{item.first_name}} {{item.last_name}}
        </v-list-item-title>
        <v-list-item-subtitle v-if="item.email" class="caption">
          {{item.email}}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import {fetchSellers} from '@/api/auth'
import notifications from '../../utils/notifications'

export default {
  name: 'SellerSelection',
  props: {
    value: {
      type: [Object, String],
      default: () => ({})
    },
    errors: {
      type: [Array, String],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    placeholder: String
  },
  data: () => ({
    items: [],
    loading: false,
    internalValue: null
  }),
  watch: {
    value: {
      handler(newVal) {
        this.internalValue = newVal
      },
      immediate: true
    }
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val)
    }
  },
  async created() {
    this.loading = true
    try {
      const res = await fetchSellers()
      this.items = res
    } catch (e) {
      notifications.showError('Error cargando vendedores: ' + e)
    } finally {
      this.loading = false
    }
  }
}
</script>